import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';
import { downloadDocumentFromS3WithoughtPreview } from '@cp/src/utils/DocumentDownloadFromS3';
import { DownloadIcon } from '@navi/web-ui/lib/icons';
import { Button, Typography } from '@navi/web-ui/lib/primitives';

const FileDownloadButton = ({
  label,
  presignedUrl,
  fileName = 'Validation Report',
  buttonContainer = 'text-center text-[--blue-base] pt-1 px-3',
  clickstreamEvent,
  attributes = {}
}: {
  label: string;
  presignedUrl: string | undefined;
  fileName?: string;
  buttonContainer?: string;
  clickstreamEvent?: { name: string; description: string };
  attributes?: Record<string, string>;
}) => {
  if (!presignedUrl) return null;

  const handleDownloadClick = () => {
    if (clickstreamEvent) {
      addClickstreamEvent(clickstreamEvent, attributes);
    }
    downloadDocumentFromS3WithoughtPreview(presignedUrl, fileName, `File download failed`);
  };

  return (
    <Button
      onClick={handleDownloadClick}
      variant="text"
      className={buttonContainer}
      endAdornment={<DownloadIcon width={16} height={16} color="var(--navi-color-blue-base)" />}
    >
      <Typography variant="h4" color="var(--navi-color-blue-base)">
        {label}
      </Typography>
    </Button>
  );
};

export default FileDownloadButton;
